import { feature } from '@libs/utils/feature/feature';

export const log = (message?: any, ...optionalParams: any[]): void => {
    if (!feature('log')) return;
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log(message, ...optionalParams);
    }
};
